import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

export const TRAILING_7_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.weeklyActiveAddressesCount,
    label: "Weekly Active Addresses",
    tooltip: CatalogMetricSlugs.trailing_7_day_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.weeklyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "trailing_7_day_active_addresses_count",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const TRAILING_30_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.trailing30DayActiveAddressesCount,
    label: (
        <>
            Trailing 30D
            <br />
            Active Addresses
        </>
    ),
    tooltip: CatalogMetricSlugs.trailing_30_day_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.trailing30DayActiveAddressesCount,
    width: 190,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "trailing_30_day_active_addresses_count",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const DAILY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyActiveAddressesCount,
    label: "Daily Active Addresses",
    tooltip: CatalogMetricSlugs.daily_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_active_addresses_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const WEEKLY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.weeklyActiveAddressesCount,
    label: "Weekly Active Addresses",
    tooltip: CatalogMetricSlugs.weekly_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.weeklyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(item, "weekly_active_addresses_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const MONTHLY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.monthlyActiveAddressesCount,
    label: "Monthly Active Addresses",
    tooltip: CatalogMetricSlugs.monthly_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.monthlyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(item, "monthly_active_addresses_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const ANNUALLY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.annuallyActiveAddressesCount,
    label: "Annually Active Addresses",
    tooltip: CatalogMetricSlugs.annually_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.annuallyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "annually_active_addresses_count",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const QUARTERLY_ACTIVE_ADDRESSES_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.quarterlyActiveAddressesCount,
    label: "Quarterly Active Addresses",
    tooltip: CatalogMetricSlugs.quarterly_active_addresses_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.quarterlyActiveAddressesCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "quarterly_active_addresses_count",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
